module.exports = __webpack_public_path__ + "static/media/homeBanner.224bf9a8.jpg";